// ** Redux Imports
import { combineReducers } from 'redux';

// ** Reducers Imports
import roleSlice from './slice//roleSlice';
import orgSlice from './slice//orgSlice';
import hotelSlice from './slice//hotelSlice';
import globalSlice from './slice/globaSlice';
import siteSlice from './slice/siteSlice';

const rootReducer = combineReducers({
   role: roleSlice.reducer,
   org: orgSlice.reducer,
   hotel: hotelSlice.reducer,
   globalConfig: globalSlice.reducer,
   site: siteSlice.reducer,
});

export default rootReducer;
